/* eslint-disable no-useless-catch */
/* eslint-disable no-param-reassign */
import { ActionTree } from 'vuex';
import {
    ITrackingServerConfig,
    HttpMethod,
} from '@andromeda/telemetry-data-access-orion';
import { getEnvironment } from '@andromeda/util-environment';
import { SET_TRACKING_CONFIGS, SEND_REPORT } from '../types';
import { IRootState } from '../mxr-store/state';
import { ITrackingState } from './state';

export const actions: ActionTree<ITrackingState, IRootState> = {
    [SET_TRACKING_CONFIGS]: async ({ commit }, payload: { host: string}): Promise<void> => {
        try {
            const { host } = { ...payload };
            const tsConfig = {
                url: `${host}/api/trk/v1/events`,
                type: 'ajax',
                method: HttpMethod.POST,
                baseParams: {},
            } as unknown as ITrackingServerConfig;
            tsConfig.url = tsConfig.url;
            commit(SET_TRACKING_CONFIGS, [tsConfig]);
            return;
        } catch (err) {
            throw err;
        }
    },
    [SEND_REPORT]: async (
        { commit },
        payload: { type: string }
    ): Promise<void> => {
        try {
            commit(SEND_REPORT, payload);
            return;
        } catch (err) {
            throw err;
        }
    },
};
